import styled from 'styled-components';
import { flexCenter } from '../../../utils/style';

export const StyledChannelListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${(props) => props.theme.colors.greys.white};
  border-right: 1px solid ${(props) => props.theme.colors.greys.grey20};
`;

export const StyledChannelListHeader = styled.div`
  flex: 0 0 4.25rem;
  font-size: ${(props) => props.theme.fontSizes.text.fontSize};
  color: ${(props) => props.theme.colors.primary.main};
  font-weight: bold;
  ${flexCenter}
`;

export const StyledChannelListCheck = styled.div`
  flex: 0 0 2rem;
  font-size: ${(props) => props.theme.fontSizes.text.fontSize};
  color: ${(props) => props.theme.colors.primary.sub};
  border-bottom: 1px solid ${(props) => props.theme.colors.greys.grey20};
  margin: 10px;
`;
